import { ArrowDropDownRounded } from '../../icons';
import { Components } from '../../material';

export const MuiSelect: Components['MuiSelect'] = {
  defaultProps: {
    IconComponent: args => <ArrowDropDownRounded {...args} />,
  },
};
